import { Component, OnInit,Input} from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingState } from '../../loading/loading.component';
import {PerExecutionService} from '../../../services/per-execution.service';
import { SettingService} from '../../../services/setting.service';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-vehicle-bike-inner-tab',
  templateUrl: './vehicle-bike-inner-tab.component.html',
  styleUrls: ['./vehicle-bike-inner-tab.component.scss']
})
export class VehicleBikeInnerTabComponent implements OnInit {
  @Input() projectId:number; 
  form: FormGroup;
  loading: LoadingState = LoadingState.NotReady;
  bikeDocumentList:any = [];
  bikeDetails:any = [];
  @Input() approveStatus:any = [];
  dialogRef: MatDialogRef<ConfirmDialogComponent>;
  
  constructor(
    private location: Location,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private perExecutionService:PerExecutionService,
    public settingService:SettingService,
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      project:[this.projectId],
      bike_model:[null,Validators.required],
      bike_details:[null,Validators.required],
      bike_cost:[null,Validators.required],
      quantity:[null,Validators.required],
      requirment_s_date:[null,Validators.required],
      requirment_e_date:[null,Validators.required],
      budgeted_cost:[null,Validators.required],
      executed_cost:[null,Validators.required],
      documents:this.formBuilder.array([
        // this.createDocument()
      ])
    })

    if(this.projectId){
      this.getBikeDetails();
    }
  }

  createDocument(){
    return this.formBuilder.group({
      document_name: [null, Validators.required],
      document: [null, Validators.required],
      bike_document: null
    })
  }

  getFormArrayControl(form) {
    return form.get('documents').controls
  }

  addDocument()
  {
    const control = <FormArray>this.form.controls['documents'];
    control.push(this.createDocument());
  }

  deleteDocument(index:number)
  {
    const control = <FormArray>this.form.controls['documents'];
    control.removeAt(index);
  }

  onSelectFile(event, index){
    console.log(event.target.files);
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event) => {
          // console.log(event.target['result']);
        }
        const control = <FormArray>this.form.controls['documents'];
        control.at(index).patchValue({
          document: event.target.files[0]['name'],
          bike_document: event.target.files[0]
        })
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  save(){
    if(this.form.valid){
      var bike_documents_data = [];
      bike_documents_data = this.form.value.documents;
      this.loading = LoadingState.Processing

      const data = {
        project: this.projectId,
        bike_model: this.form.value.bike_model,
        bike_details:this.form.value.bike_details,
        bike_cost: this.form.value.bike_cost,
        quantity: this.form.value.quantity,
        requirment_s_date: this.settingService.getProperDate(this.form.value.requirment_s_date).toISOString(),//aa
        requirment_e_date: this.settingService.getProperDate(this.form.value.requirment_e_date).toISOString(),//aa
        budgeted_cost: this.form.value.budgeted_cost,
        executed_cost: this.form.value.executed_cost,
      }
      this.bikeDocumentList = [];
      this.perExecutionService.addBikeOffice(data).subscribe(
        res => {
          var forkArray = [];

          bike_documents_data.forEach(x => {
              const formData: any = new FormData();
              formData.append("project",this.projectId);
              formData.append("module_id", res.id);
              formData.append("document_name", x.document_name);
              formData.append("document", x.bike_document, x.bike_document['name']);
              forkArray.push(this.perExecutionService.addBikeDocumentOffice(formData))
          })
          forkJoin(forkArray).subscribe(
            (result: any[]) => {
              // console.log(result)
              result.forEach(y => {
                this.bikeDocumentList.push(y)
              })
              
              // this.add_tender_document()
              this.loading = LoadingState.Ready;
            },
            err => {
              this.loading = LoadingState.Ready;
              // console.log(err)
            }
          )
          this.loading = LoadingState.Ready;
          this.toastr.success('Data has been saved','',{
            timeOut: 3000,
          });
        },
        error=>{
          console.log(error);
          this.loading = LoadingState.Ready;
          this.toastr.error('Something went wrong', '', {
            timeOut: 3000,
          });
        }
      )
      console.log(data);
    }else{
      this.markFormGroupTouched(this.form);
    }
  }

  getBikeDetails(){
    this.perExecutionService.getBikeOffice(this.projectId).subscribe(
      res=>{
        if(res['result'][0]){
          this.bikeDetails = res['result'][0];
          console.log(this.bikeDetails);
          this.bikeDocumentList = res['result'][0].document_details;
          var start_date = new Date(this.bikeDetails['requirment_s_date'])
            this.bikeDetails.requirment_s_date = {
              year: start_date.getFullYear(),
              month: start_date.getMonth()+1,
              day: start_date.getDate()
        
            }
            var end_date = new Date(this.bikeDetails['requirment_e_date'])
            this.bikeDetails.requirment_e_date = {
              year: end_date.getFullYear(),
              month: end_date.getMonth()+1,
              day: end_date.getDate()
              
            }

          this.bikeDetails.bike_cost = parseFloat(this.bikeDetails.bike_cost).toFixed(2);
          this.bikeDetails.budgeted_cost = parseFloat(this.bikeDetails.budgeted_cost).toFixed(2);
          this.bikeDetails.executed_cost = parseFloat(this.bikeDetails.executed_cost).toFixed(2);
        }
        this.loading = LoadingState.Ready;
      },
      error => {
        console.log(error);
        this.loading = LoadingState.Ready;
        this.toastr.error('Something went wrong', '', {
          timeOut: 3000,
        });
      }
    )
  }
  getFile(file: string) {
    var fileName = file.split('.')
    var fileExt = fileName[fileName.length - 1];
    if (fileExt == 'jpg' || fileExt == 'jpeg' || fileExt == 'png') {
      return file;
    }
    else {
      return 'assets/img/pdf.png'
    }
  }

  editDoc(index) {
    this.bikeDocumentList[index]['isEdit'] = true
    this.bikeDocumentList[index]['isFieldError'] = false
  }

  renameDoc(index) {
    if (this.bikeDocumentList[index]['document_name'] == '') {
      this.bikeDocumentList[index]['isFieldError'] = true;
    }
    else {
      this.loading = LoadingState.Processing
      this.bikeDocumentList[index]['isFieldError'] = false;
      var data = {
        document_name: this.bikeDocumentList[index]['document_name']
      }

      
      this.perExecutionService.editBikeDocumentOffice(this.bikeDocumentList[index]['id'], data).subscribe(
        res => {
          // console.log(res)
          this.bikeDocumentList[index]['isEdit'] = false
          this.loading = LoadingState.Ready
        },
        error => {
          // console.log(error)
          this.loading = LoadingState.Ready
        }
      )
    }
  }

  deleteDoc(index) {

    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: false
    });

    this.dialogRef.componentInstance.confirmMessage = "Are you sure you want to delete?"

    this.dialogRef.afterClosed().subscribe(result => {
     if(result){
      this.loading = LoadingState.Processing
      this.perExecutionService.deleteBikeDocumentOffice(this.bikeDocumentList[index]['id']).subscribe(
        res => {
          this.bikeDocumentList.splice(index, 1)
          // console.log(res)
          this.loading = LoadingState.Ready
        },
        error => {
          // console.log(error)
          this.loading = LoadingState.Ready
        }
      )
	 }
	 this.dialogRef = null;
	 })
  
  }

  update(){
    if(this.form.valid){
      //console.log(this.bikeDetails);
      var bike_documents_data = [];
      bike_documents_data = this.form.value.documents;

      if(this.form.value.documents.length > 0){
        var forkArray = [];
        bike_documents_data.forEach(x => {
            const formData: any = new FormData();
            formData.append("project", this.projectId);
            formData.append("module_id", this.bikeDetails.id);
            formData.append("document_name", x.document_name);
            formData.append("document", x.bike_document, x.bike_document['name']);
            forkArray.push(this.perExecutionService.addBikeDocumentOffice(formData))
        })
        forkJoin(forkArray).subscribe(
          result => {
            // console.log(result)
            result.forEach(y => {
              this.bikeDocumentList.push(y)
            })
           
            // this.add_tender_document();
            this.loading = LoadingState.Ready;
          },
          err => {
            this.loading = LoadingState.Ready;
            // console.log(err)
          }
        )
        this.updateBike();
      }

      else{
        this.updateBike();
      }
    }else{
      this.markFormGroupTouched(this.form);
    }
  }
  updateBike(){
    if(this.form.valid){
      this.loading = LoadingState.Processing

      const updateData = {
        project: this.projectId,
        bike_model: this.form.value.bike_model,
        bike_details:this.form.value.bike_details,
        bike_cost: this.form.value.bike_cost,
        quantity: this.form.value.quantity,
        requirment_s_date: this.settingService.getProperDate(this.form.value.requirment_s_date).toISOString(),//aa
        requirment_e_date: this.settingService.getProperDate(this.form.value.requirment_e_date).toISOString(),//aa
        budgeted_cost: this.form.value.budgeted_cost,
        executed_cost: this.form.value.executed_cost,
      }

      this.perExecutionService.editBikeOffice(this.bikeDetails.id,updateData).subscribe(
        res =>{
         // console.log(res)
          this.loading = LoadingState.Ready;
          
          this.toastr.success('Data has been saved','',{
            timeOut: 3000,
          });
        },
        error =>{
         this.loading = LoadingState.Ready;
         console.log(error);
         this.toastr.error('Something went wrong', '', {
          timeOut: 3000,
        });
        }
      )

    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

  isFieldValid(form: FormGroup, field: string) {
    return !form.get(field).valid && (form.get(field).dirty || form.get(field).touched);
  }

  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid': form.get(field).invalid && (form.get(field).dirty || form.get(field).touched),
      'is-valid': form.get(field).valid && (form.get(field).dirty || form.get(field).touched)
    };
  }

}
